import Vuex from 'vuex';

import * as getters from '../../store/player-profile/getters';

const createStore = () => {
    return new Vuex.Store({
        modules: {
            'player-profile': {
                namespaced: true,

                state: {
                    profile: {
                        general: {
                            birth_date: []
                        },
                        contacts: {
                        },
                        educations: [],
                        stats: {
                            athletics: {},
                            performances: {}
                        },
                        showcases: [],
                    },
                    sessions: [],
                    actions: [],
                    videos: [],
                    user: {
                        id: ''
                    },
                },

                actions: {
                    fetchPublicProfile({ commit }, userID) {
                        return window.axios.get(`public/profile/${userID}`)
                            .then(response => commit('setProfile', response.data));
                    }
                },

                mutations: {
                    setProfile(state, payload) {
                        state.profile = payload;
                    },

                    setUserID(state, userID) {
                        state.user.id = userID;
                    }
                },

                getters
            }
        }
    });
};

export default createStore;
